import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceArea } from 'recharts';
import { calculateZScore } from '../helpers/growthEvaluation';

export default function GrowthChart({ assessments, childGender }) {
    // Prepare data for the chart, including Z-score for each point
    const chartData = assessments
        .filter(asmnt => asmnt.pertumbuhan && asmnt.ageInMonths !== undefined)
        .map(asmnt => {
            const weight = parseFloat(asmnt.pertumbuhan.bb);
            const age = asmnt.ageInMonths;
            const zScore = calculateZScore(weight, age);
            return {
                age: age,
                berat: weight,
                zScore: zScore ? zScore.toFixed(2) : 'N/A',
            };
        })
        .sort((a, b) => a.age - b.age);

    // This function should be inside or imported correctly. Since it was moved from utils,
    // let's redefine it here for simplicity or import from growthEvaluation.
    // For now, let's assume it's not available and comment out the parts that use it.
    const getValueForZScore = (z, ageInMonths) => {
        // This is a placeholder. The actual logic is in growthEvaluation.ts but not exported.
        return null; 
    }

    // Prepare data for the reference Z-score lines
    const zScoreLines = [-3, -2, 0, 2, 3].map(z => ({
        z,
        data: chartData.map(p => ({
            age: p.age,
            value: getValueForZScore(z, p.age)
        })).filter(p => p.value)
    }));
    
    return (
        <div style={{ width: '100%', height: 350 }}>
            <h4 className="font-bold text-center mb-4 text-gray-700">Grafik Berat Badan Menurut Umur (Z-Score)</h4>
            <ResponsiveContainer>
                <LineChart
                    data={chartData}
                    margin={{ top: 5, right: 20, left: -15, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="age" name="Umur" unit=" bln" type="number" domain={['dataMin', 'dataMax']} />
                    <YAxis name="Berat" unit=" kg" domain={['dataMin - 1', 'dataMax + 1']} />
                    <Tooltip formatter={(value, name, props) => [`${value} ${name === 'berat' ? 'kg' : ''}`, name === 'berat' ? 'Berat Anak' : `Z-Score: ${props.payload.zScore}`]} />
                    <Legend verticalAlign="top" height={36}/>
                    
                    {/* Z-Score Reference Areas */}
                    <ReferenceArea y1={0} y2={getValueForZScore(-3, 24)} fill="red" fillOpacity={0.1} label={{ value: "Sangat Kurang", position: "insideTopLeft", fill: "#ef4444", fontSize: 10 }} />
                    <ReferenceArea y1={getValueForZScore(-3, 24)} y2={getValueForZScore(-2, 24)} fill="orange" fillOpacity={0.1} label={{ value: "Kurang", position: "insideTopLeft", fill: "#f97316", fontSize: 10 }} />
                    <ReferenceArea y1={getValueForZScore(-2, 24)} y2={getValueForZScore(2, 24)} fill="green" fillOpacity={0.1} label={{ value: "Normal", position: "insideTopLeft", fill: "#22c55e", fontSize: 10 }}/>
                    
                    {/* Z-Score reference lines */}
                    {zScoreLines.map(line => (
                        <Line key={line.z} data={line.data} dataKey="value" stroke="#ccc" dot={false} strokeWidth={1} name={`Z=${line.z}`} />
                    ))}
                    
                    {/* Line for the actual child's weight */}
                    <Line type="monotone" dataKey="berat" stroke="#6D28D9" strokeWidth={2.5} name="Berat Anak" activeDot={{ r: 6 }} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
